// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .offer-tabs{margin-top:0}#openbay .offer-tabs .tab-pane{padding:1rem}@media(max-width:768px){#openbay .location-map{margin-bottom:1rem}}#openbay .nav.nav-tabs li a{text-transform:normal;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
